import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, ChevronRight } from "lucide-react";
import { NAV } from "@/lib/constants";

const ALIASES = { "/app/evenements": "/app/calendrier" };
const EXTRA = { "/app/compte": "Mon compte", "/app/parametres": "Paramètres", "/app/valhalla": "Valhalla", "/app/module": "Module" };

function trail(path) {
  if (path === "/app" || path === "/app/") return [];
  const segs = path.split("/").filter(Boolean);
  const base = `/${segs[0]}/${segs[1] || ""}`;
  const target = ALIASES[base] || base;
  const nav = [...NAV].sort((a, b) => b.to.length - a.to.length).find((n) => n.to !== "/app" && path.startsWith(n.to))
    || NAV.find((n) => n.to === target);
  const label = nav?.label || EXTRA[base];
  if (!label) return [];
  const items = [{ label, to: nav?.to || base }];
  const rest = path.slice((nav && path.startsWith(nav.to) ? nav.to : base).length).split("/").filter(Boolean);
  if (rest.length) items.push({ label: rest[0] === "nouveau" ? "Nouveau" : "Détail" });
  return items;
}

export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const items = trail(pathname);
  return (
    <nav aria-label="Fil d'Ariane" data-testid="breadcrumbs" className="hidden min-w-0 items-center gap-1.5 text-sm md:flex">
      <Link to="/app" data-testid="breadcrumb-home" className={`flex items-center gap-1.5 rounded-md px-1.5 py-1 transition-colors hover:text-white ${items.length ? "text-zinc-500" : "font-medium text-white"}`}>
        <Home className="h-4 w-4" strokeWidth={1.7} />Tableau de bord
      </Link>
      {items.map((it, i) => (
        <React.Fragment key={i}>
          <ChevronRight className="h-3.5 w-3.5 text-zinc-700" />
          {it.to && i < items.length - 1
            ? <Link to={it.to} data-testid={`breadcrumb-${i}`} className="truncate rounded-md px-1.5 py-1 text-zinc-500 transition-colors hover:text-white">{it.label}</Link>
            : <span data-testid={`breadcrumb-${i}`} className="truncate rounded-md bg-zinc-800/60 px-2 py-0.5 font-medium text-white">{it.label}</span>}
        </React.Fragment>
      ))}
    </nav>
  );
}
